import type { DataTypes } from 'fitify-ui-landing/src/@types'
import { Text } from 'fitify-ui-landing/src/components/Text'
import { useTranslation } from 'next-i18next'

import { StyledWorkStatisticsItem } from './WorkStatistics.Styled'

const WorkStatisticsItem = ({
  icon,
  iconColor,
  percent,
  content,
}: DataTypes.WorkStatisticItem) => {
  const { t } = useTranslation()

  return (
    <StyledWorkStatisticsItem $iconColor={iconColor}>
      {icon}
      <Text as={'p'} variant={'work-statistics-percent'}>
        {percent}
      </Text>
      <Text as={'p'} variant={'h5'} style={{ width: '80%' }} color={'Gray600'}>
        {t(content)}
      </Text>
    </StyledWorkStatisticsItem>
  )
}

export default WorkStatisticsItem
